import {StoreType} from '..';
import {IContributionResponse} from '../../utils/types';

export const getAttendeeContributionLoaderSelector = (state: StoreType): boolean =>
	state.organizationAttendeesContributionsStore.isLoading;

export const getAttendeesContributionSelector = (state: StoreType): IContributionResponse =>
	state.organizationAttendeesContributionsStore.attendeeContributions;
